import PropTypes from 'prop-types';

export const BtnAprobarModerador = ({ estado, setEstado, isCategory, isAdminMod }) => {
    if (estado === "activo" && (isCategory || isAdminMod)) {
        return null;
    }

    if (isCategory || isAdminMod) {
        return (
            <button
                name="activo"
                onClick={setEstado}
                className="btn background-rojo-megatone waves-effect waves-light btn-sm m-r-10"
                disabled={estado === "activo"}
            >
                Aprobar
            </button>
        );
    }

    return null;
}
BtnAprobarModerador.propTypes = {
    estado: PropTypes.string,
    setEstado: PropTypes.func,
    isCategory: PropTypes.bool,
    isAdminMod: PropTypes.bool,
}